import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("an_admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-obsidian px-6" data-testid="admin-login-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-sm"
      >
        <Link to="/" className="mb-10 block text-center font-display text-xl font-semibold tracking-[0.2em] text-bone">
          ATELIER <span className="text-vermilion">NORTE</span>
        </Link>
        <form onSubmit={submit} className="border border-white/10 bg-onyx p-8">
          <p className="mb-6 text-center font-mono text-xs uppercase tracking-[0.35em] text-faint">Atelier Office</p>
          {error && (
            <p className="mb-4 border border-red-500/30 bg-red-500/10 px-4 py-3 font-mono text-[11px] tracking-wider text-red-400" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <div className="flex flex-col gap-3">
            <input
              type="email"
              required
              placeholder="EMAIL"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              className="border border-white/15 bg-obsidian px-4 py-3.5 font-mono text-xs tracking-wider text-bone outline-none placeholder:text-faint focus:border-vermilion"
            />
            <input
              type="password"
              required
              placeholder="PASSWORD"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-passcode-input"
              className="border border-white/15 bg-obsidian px-4 py-3.5 font-mono text-xs tracking-wider text-bone outline-none placeholder:text-faint focus:border-vermilion"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-login-submit"
              className="mt-2 flex items-center justify-center gap-2 bg-vermilion py-4 font-mono text-xs uppercase tracking-[0.3em] text-obsidian transition-colors hover:bg-vermilion-dark disabled:opacity-40"
            >
              {loading ? <Loader2 className="animate-spin" size={16} /> : "Unlock the Office"}
            </button>
          </div>
        </form>
        <Link to="/" className="mt-6 block text-center font-mono text-[10px] uppercase tracking-[0.3em] text-faint transition-colors hover:text-smoke">
          ← Return to the storefront
        </Link>
      </motion.div>
    </div>
  );
}
